// Statuts financiers des commandes Shopify
export const orderFinancialLabels = {
    paid: { label: 'Payé', color: 'text-green-500' },
    pending: { label: 'En attente', color: 'text-orange-500' },
    refunded: { label: 'Remboursé', color: 'text-red-500' },
    partially_refunded: { label: 'Part. remboursé', color: 'text-orange-500' },
    partially_paid: { label: 'Part. payé', color: 'text-orange-500' },
    voided: { label: 'Annulé', color: 'text-gray-500' },
    authorized: { label: 'Autorisé', color: 'text-blue-500' },
}

// Statuts d'expédition des commandes Shopify
export const orderFulfillmentLabels = {
    fulfilled: { label: 'Expédié', color: 'text-green-500' },
    unfulfilled: { label: 'Non expédié', color: 'text-orange-500' },
    partial: { label: 'Part. expédié', color: 'text-orange-500' },
    restocked: { label: 'Restocké', color: 'text-gray-500' },
}
